import './draggableAvailableItem';
import './packagingSelect';
import './packagingDuplicate';
import './packaging';
import './packagingArea';
import './availableItemsArea';
import './packageInfo';
import './otherPackageSelect';
import './serviceCodeParam';
import './virtualKeyboard';

angular.module("wco.directives",
    [
        "wco.directives.draggableAvailableItem",
        "wco.directives.packagingSelect",
        "wco.directives.packagingDuplicate",
        "wco.directives.packagingArea",
        "wco.directives.packaging",
        "wco.directives.availableItemsArea",
        "wco.directives.packageInfo",
        "wco.directives.otherPackageSelect",
        "wco.directives.serviceCodeParam",
        "wco.directives.virtualKeyboard"
    ]
);
